"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getDownArrowSize = function getDownArrowSize(size) {
  return size === 'small' ? (0, _index.cssGraphicSize)('smaller', 'decorative', '16px') : (0, _index.cssGraphicSize)('base', 'decorative', '24px');
};
var Button = exports.Button = _styledComponents["default"].button.withConfig({
  displayName: "Button",
  componentId: "sc-nfsrja-0"
})(["", ""], function (_ref) {
  var $size = _ref.$size,
    $useBrowserDefaultFocusStyle = _ref.$useBrowserDefaultFocusStyle,
    $isUsingKeyboard = _ref.$isUsingKeyboard,
    $isHover = _ref.$isHover,
    $isFocus = _ref.$isFocus,
    $error = _ref.$error;
  return (0, _styledComponents.css)(["", ";text-align:start;overflow-wrap:break-word;min-block-size:", ";border-radius:", ";padding-block:", ";padding-inline:", " calc((2 * ", ") + ", ");", ";"], (0, _index.formControlBase)($useBrowserDefaultFocusStyle), $size === 'small' ? (0, _index.cssControlSize)('smaller', _index.controlSizeFallback.small) : (0, _index.cssControlSize)('base', _index.controlSizeFallback.medium), (0, _index.cssBorderRadius)('base', '4px'), (0, _index.getFormPaddingBlock)($size), (0, _index.getFormPaddingInline)($size), (0, _index.getFormPaddingInline)($size), getDownArrowSize($size), (0, _index.formControlTheme)({
    isUsingKeyboard: $isUsingKeyboard,
    isHover: $isHover,
    isFocus: $isFocus,
    error: $error,
    useBrowserDefaultFocusStyle: $useBrowserDefaultFocusStyle
  }));
});